import { slideToggle } from '../core/effects.js';

export function initHeader() {
  if (document.documentElement.dataset.webtenseHeaderInit) {
    return;
  }

  document.documentElement.dataset.webtenseHeaderInit = 'true';
  const header = document.querySelector('header');

  function toggleFixedHeader() {
    header?.classList.toggle('_fixed', window.scrollY > 30);
  }

  toggleFixedHeader();
  window.addEventListener('scroll', toggleFixedHeader);

  document.querySelectorAll('.menu-content').forEach((element) => {
    element.classList.remove('d-none');
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.mobile-menu-button')) {
      document.querySelectorAll('.mobile-menu-button').forEach((button) => button.classList.toggle('active'));
      document.querySelector('.mobile-nav')?.classList.toggle('active');
      return;
    }

    const menuToggle = event.target.closest('.main-menu__link_parent-toggle, .submenu__link_parent-toggle');
    if (menuToggle && window.innerWidth <= 991) {
      event.preventDefault();
      const parent = menuToggle.parentElement;
      parent?.classList.toggle('active');
      slideToggle(parent?.nextElementSibling);
      return;
    }

    const footerToggle = event.target.closest('.footer__menu-title-toggle');
    if (footerToggle && window.innerWidth <= 767) {
      event.preventDefault();
      const titleWrapper = footerToggle.parentElement;
      titleWrapper?.classList.toggle('active');
      slideToggle(titleWrapper?.parentElement?.nextElementSibling);
    }
  });
}
